import { render, staticRenderFns } from "./RoomGroupVideoFilmContainer.vue?vue&type=template&id=908111f6&scoped=true&"
import script from "./RoomGroupVideoFilmContainer.vue?vue&type=script&lang=js&"
export * from "./RoomGroupVideoFilmContainer.vue?vue&type=script&lang=js&"
import style0 from "./RoomGroupVideoFilmContainer.vue?vue&type=style&index=0&id=908111f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908111f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('908111f6')) {
      api.createRecord('908111f6', component.options)
    } else {
      api.reload('908111f6', component.options)
    }
    module.hot.accept("./RoomGroupVideoFilmContainer.vue?vue&type=template&id=908111f6&scoped=true&", function () {
      api.rerender('908111f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Group/RoomGroupCall/RoomGroupVideoFilmContainer.vue"
export default component.exports